import { UpdateSiteCommand, UpdateSiteCommandInput } from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";
import { Site } from "src/sites/types";

export async function updateSiteService(site: Site) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return Promise.reject(new Error("Unauthorized"));
  }
  const command = new UpdateSiteCommand(site as UpdateSiteCommandInput);
  const metricsPublisher = new MetricsPublisher("api.updateSite");

  return await client
    .send(command)
    .then((response: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
